import React, { Component } from 'react';
import { connect } from 'react-redux';
import config from '../../config';

import { Button, Steps, Row, Col, message } from 'antd';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';

import { createUserBot } from '../../reducers/user/resources';
import { getUserProducts } from '../../reducers/products/resources';
import { getAssignedBots, getBotTemplates,getUserCompanyBots } from '../../reducers/bots/resources';
import { searchLocation } from '../../reducers/common/resources';

import { checkIfHasService } from '../../utils/user';

import { WelcomeContent,WelcomeDoneForYouContent, SetupComplete } from './start-end';
import LocationConfig from './location';
import CalendarConfig from './calendar';
import AutoBotConfig from './autobot';

import './done-for-you/index.css'

import _ from 'lodash';
import moment from 'moment';
import session from '../../utils/session';
import { SpinnerDotted } from 'spinners-react';
class ForgotPassword extends Component {
	componentWillMount() {
		let selectedDays = [false, true, true, true, true, true, false];

		const sTime = new Date();
		sTime.setHours(9);
		sTime.setMinutes(0);
		const startTime = {
			value: sTime,
			error: ''
		};

		const eTime = new Date();
		eTime.setHours(12);
		eTime.setMinutes(0);
		const endTime = {
			value: eTime,
			error: ''
		};

		this.setState({
			newUser: false,
			stepIndex: 0,
			showSnackBar: false,
			snackBarMessage: '',
			hasSms: undefined,
			hasQR: false,
			zones: [],
			zone: '',
			steps: [],
			zoneError: '',
			selectedDays,
			startTime,
			endTime,
			interviewSlots: [
				{ day: 1, startTime: '09:00 AM', endTime: '05:00 PM' },
				{ day: 2, startTime: '09:00 AM', endTime: '05:00 PM' },
				{ day: 3, startTime: '09:00 AM', endTime: '05:00 PM' },
				{ day: 4, startTime: '09:00 AM', endTime: '05:00 PM' },
				{ day: 5, startTime: '09:00 AM', endTime: '05:00 PM' },
			],
			confirmationMsg: '',
			hrDuration: 0,
			minDuration: 30,
			maxPerInterviewSlot: 1,
			includeStoreLocation: false,
			noInterviewsWithinPeriod: 'h',
			noInterviewsWithinNumber: 0,
			noInterviewsWithin: '0h',
			skips: ['calendar'],
			timeout: null,
			selectedLoc: {},
			autobotTemplate: null,
			brandName:"",
			careerSiteUrl:"https://",
			careerSiteError:"",
			brandNameError:"",
			qrImage:"",
			botTemplates:[],
			scheduleSequence:'random',
			script:[],
			showLoader:true
		});

		(async () => {
			let userproducts = await getUserProducts();
			let userBots = await getAssignedBots();
			let {data:botTemplates}= await getBotTemplates();
			const { parent_user } = session.get('userData');
			
			let abt = _.find(userBots.data,{'default':null,'type':'nexmo'})
			let companyBots = await getUserCompanyBots();
			const qrImage = `${config.api.host}/api/v1/files/bot/qr/${abt? abt.qr_image : ""}`
			let hasQR = false;
			let existingABT = false;
			
			if(companyBots && companyBots.data.length){
				existingABT = _.find(companyBots.data,{'default':null,'type':'nexmo'})
			}

			userproducts = userproducts.data;
			const steps = ['welcome', 'location'];
			if (checkIfHasService(userproducts, 'calendar')) {
				steps.push('calendar');
			}

			let hasSms = checkIfHasService(userproducts, 'sms');

			/**
			 * display QR if has the following conditions:
			 * - autosmb service
			 * - does not have existing ABT
			 * - is not a child company user
			 */
			if (checkIfHasService(userproducts, 'autosmb') && !existingABT && !parent_user) {
				hasQR = true;
			}

			steps.push('complete');

			this.setState({ steps, hasSms, hasQR, qrImage, botTemplates, showLoader:false });
		})();
	}

	componentDidUpdate() {
		if (this.state.showSnackBar && this.state.snackBarMessage) {
			message.warning(this.state.snackBarMessage);
			this.setState({ showSnackBar: false, snackBarMessage: '' });
		}
	}

	handleNext = (skip = false) => async () => {
		let { stepIndex, steps, zone, selectedLoc, autobotTemplate, hasQR,brandName,careerSiteUrl } = this.state;

		try {
			if (!skip) {
				switch (steps[stepIndex]) {
					case 'welcome':
						if(hasQR){
							if((brandName||'').trim().length === 0){
								return this.setState({
									brandNameError: 'Please enter your brand name',
									showSnackBar: true,
									snackBarMessage: 'Brand name required'
								});
							}
							if((careerSiteUrl||'').trim().length === 0 || careerSiteUrl.trim()==='https://'){
								return this.setState({
									careerSiteError: 'Please enter your career site URL',
									showSnackBar: true,
									snackBarMessage: 'Career site URL is required'
								});
							}
						}
						break;
					case 'location':
						if (zone === '') {
							return this.setState({
								zoneError: 'Please select a location',
								showSnackBar: true,
								snackBarMessage: 'User location is required'
							});
						} else if (
							_.isEmpty(selectedLoc) ||
							(!_.isEmpty(selectedLoc) && selectedLoc.formatted_address !== zone)
						) {
							// The inputted location is invalid
							// The user did not select a location from the auto complete dropdown
							return this.setState({
								zoneError: 'Please select a location',
								showSnackBar: true,
								snackBarMessage: 'Please input and select a valid location'
							});
						}
						break;
					case 'calendar':
						break;
					
					default:
						let pathname = '/inbox';
						if (this.state.steps.includes('calendar')) {
							pathname = '/account-setup/integrate-calendar';
						}

						return this.props.history.replace({ pathname });
				}
			}

			if (steps[stepIndex + 1] === 'complete') {
				this.setState({
					showLoader:true
				})
				await this.createUserBot();
			}

			return this.setState({
				stepIndex: stepIndex + 1,
				showLoader:false
			});
		} catch (error) {
			const { message } = error;
			return this.setState({
				showSnackBar: true,
				snackBarMessage: message || error,
			});
		}
	};

	handleOnChange = (field, isSelect) => (obj, arg1, arg2) => {
		const state = this.state;

		const timeFields = ['startTime', 'endTime'];

		let value = arg1;
		if (isSelect) {
			value = arg2;
		}

		if (timeFields.includes(field)) {
			state[field].value = value;

			state['startTime'].error = '';
			state['endTime'].error = '';

			const isTimeValid = this.validateTime(
				state['startTime'].value,
				state['endTime'].value
			);
			if (!isTimeValid) {
				state[field].error = 'Selected time is invalid';
			}
		} else if (
			['maxPerInterviewSlot', 'noInterviewsWithinNumber'].includes(field)
		  ) {
			value = value.replace(/\D/g, '')
			let val = parseInt(value) || 0
			state[field] = val > 100 ? 100 : value
			if (field === 'noInterviewsWithinNumber') {
			  state[
				'noInterviewsWithin'
			  ] = `${val}${this.state.noInterviewsWithinPeriod}`
			}
		  } else if (['noInterviewsWithinPeriod'].includes(field)) {
			state[field] = value
			state[
			  'noInterviewsWithin'
			] = `${this.state.noInterviewsWithinNumber}${value}`
		  }else if (
			['careerSiteUrl', 'brandName'].includes(field)
		  ){
			if(value.length){
				switch(field){
					case 'careerSiteUrl': state['careerSiteError'] = ""; break;
					case 'brandName': state['brandNameError'] = ""; break;
				}
			}
			state[field] = value;
		  }
		  else {
			state[field] = value;
		}

		this.setState(state);
	};

	handleOnCheck = index => (obj, isChecked) => {
		let { selectedDays } = this.state;

		selectedDays[index] = isChecked;

		this.setState({ selectedDays });
	};

	handleChangeField = field => (event, i, value) => {
		let state = { ...this.state };
		state[field] = value;
		this.setState(state);
	};

	getNextModule=(module)=>{
		const {fallback,connection,sample_reply} = module
		if(sample_reply && connection.length>0){
		  let next = null;
		  let matched = false;
	
		  _.forEach(connection,(con)=>{
			  let filters = con.filters.split(',')
			  let found = false;
	
			  _.forEach(filters,(filter)=>{
				if(filter.toLowerCase().trim()===sample_reply.toLowerCase().trim()){
				  found = true;
				  return false;
				}
			  })
	
			  if(found){
				next = con.goto
				return false;
			  }
		  })
		  return next;
		} else if(sample_reply){
			return fallback
		}
		return null
	  }
	
	  polyFillDetails = (template)=>{
	
		const contactdetails = {
		  firstname: this.state.firstname || 'John',
		  lastname: this.state.lastname || 'Smith',
		  BrandName: this.state.brandName || 'GoHire',
		  email: this.state.email || 'johns@gohire.com',
		  CompanyCareerSiteURL: this.state.careerSiteUrl || 'https://gohire.com',
		  fakezip:'94070',
		  fakeMatch: 'San Carlos, CA, US'
		}
	
		const regularEx = /{{([\s\S]+?)}}/g;
		let matches = template.match(regularEx);
		let output = template;
	
		try{
		if (matches && matches.length) {
			matches = _.map(matches, match => {
				return match.slice(2, match.length - 2).trim().toLowerCase();
			});
	
			const templateData = {};
			matches.forEach(match => {
				templateData[match] = '';
			});
	
			const keys = Object.keys(contactdetails);
			keys.forEach((key, index) => {
			  templateData[key] = contactdetails[key];
			});
	
			_.templateSettings.interpolate = regularEx;
	
			const compiled = _.template(template);
	
			output = compiled(templateData);
		}}catch(e){
		  console.log(e)
		}
	
		return output;
	  }
	
	  polyFillOptions = (module)=> {
	   let options = Object.values(module.options)
	   let optstr = '';
	   options.forEach((val,i)=>{
		let str = `\n${i+1}. ${val.trim()}`
		optstr += str
	   })
	   
	   return module.response.replace('<%=options%>',`${optstr}`).replace('<%=options %>',`${optstr}`)
	  }

	genScript=(templateId)=>{
		const template = _.find(this.state.botTemplates,{id:templateId})
		const {modules,start_module} = template
		let next =  start_module
		let curModule = _.find(modules,{id:next})
		let script = []
	
		script.push({
		  name: `msg-${Date.now()}-start`,
		  msg: `Jobs`,
		  align: "right",
		})
	
		for(let i=1; curModule && next; i++, curModule = _.find(modules,{id:next})){
		  
		  let response = curModule.response;
	
		  if(curModule.reply_type=='options'){
			response = this.polyFillOptions(curModule)
		  }
	
	
		  let botMsg  = {
			name: `msg-${Date.now()}-${i}`,
			msg: this.polyFillDetails(response),
			align: "left",
		  }
		  
		  script.push(botMsg)
	
		  if(curModule.reply_type=='zip-code'){
			script.push({name: `msg-${Date.now()}-${i}-2`,
			msg: this.polyFillDetails(`{{fakeMatch}}`),
			align: "left",})
		  }
	
		  if(curModule.sample_reply){
			let reply = {
			  name: `msg-${Date.now()}-${i}-3`,
			  msg: this.polyFillDetails(curModule.sample_reply),
			  align: "right",
			}
			script.push(reply)
		  }
		  next = this.getNextModule(curModule)
		}
		// console.log('script',script)
		return script
	  }

	handleSelectTemplate = (templateId) => {
		let state = { ...this.state }
		state['autobotTemplate'] = templateId
		state['script'] = this.genScript(templateId)
		this.setState(state)
	  }


	validateTime = (startTime, endTime) => {
		if (!(startTime instanceof Date) || !(endTime instanceof Date)) {
			return true;
		}

		startTime = moment(startTime);
		endTime = moment(endTime);

		if (endTime.isAfter(startTime)) {
			return true;
		}

		return false;
	};

	handleIncludeStoreLocationCheck = (index) => (obj, isChecked) => {
		this.setState({ includeStoreLocation: isChecked })
	  }

	handlePrev = () => {
		const { stepIndex } = this.state;
		if (stepIndex === 0) return;

		this.setState({
			stepIndex: stepIndex - 1
		});
	};

	addSlot = () => {
		this.setState((s) => ({
			interviewSlots: [
				...s.interviewSlots,
				{ day: 1, startTime: '09:00 AM', endTime: '05:00 PM' },
			],
		}));
	};

	removeSlot = (index) => {
		this.setState((s) => {
			const updated = s.interviewSlots.filter((_, i) => i !== index);
			return {
				interviewSlots: updated.length
					? updated
					: [{ day: 1, startTime: '09:00 AM', endTime: '05:00 PM' }],
			};
		});
	};

	updateSlot = (index, field, value) => {
		this.setState((s) => {
			const updated = [...s.interviewSlots];
			updated[index] = { ...updated[index], [field]: value };
			return { interviewSlots: updated };
		});
	};

	// Per-slot validation: each window must have a start strictly before its end.
	// Returns an array parallel to `slots` of error strings (or null when valid).
	getSlotErrors = (slots) => {
		const list = slots || [];

		// 1) Per-row validity: each window must have a start strictly before its end.
		const errors = list.map((slot) => {
			const st = moment(slot.startTime, 'h:mm A');
			const et = moment(slot.endTime, 'h:mm A');
			if (!st.isValid() || !et.isValid()) {
				return 'Please set a valid start and end time.';
			}
			if (!et.isAfter(st)) {
				return 'End time must be after start time.';
			}
			return null;
		});

		// 2) Same-day overlap: group still-valid rows by day, sort by start, and
		// flag any window that begins before the previous one on that day ends
		// (mirrors interview-invites validateCalendarForm).
		const byDay = new Map();
		list.forEach((slot, i) => {
			if (errors[i]) return;
			if (!byDay.has(slot.day)) byDay.set(slot.day, []);
			byDay.get(slot.day).push(i);
		});
		byDay.forEach((indices) => {
			const sorted = [...indices].sort(
				(a, b) => moment(list[a].startTime, 'h:mm A').valueOf() - moment(list[b].startTime, 'h:mm A').valueOf()
			);
			for (let k = 1; k < sorted.length; k += 1) {
				const prev = sorted[k - 1];
				const cur = sorted[k];
				if (moment(list[cur].startTime, 'h:mm A').isBefore(moment(list[prev].endTime, 'h:mm A'))) {
					errors[cur] = 'Time windows must not overlap.';
					errors[prev] = errors[prev] || 'Time windows must not overlap.';
				}
			}
		});

		return errors;
	};

	// Build the per-day multi-window `interviewSchedule` (the source of truth the
	// backend persists) from the flat slots array. Mirrors interview-invites'
	// slotsToSchedule so non-contiguous windows (e.g. Mon 9-10 + Mon 2-4) are kept.
	slotsToSchedule = (slots) => {
		const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
		return dayNames.map((name, key) => {
			const daySlots = (slots || []).filter((s) => s.day === key);
			return {
				key,
				name,
				isActive: daySlots.length > 0,
				windows: daySlots.map((s) => ({ startTime: s.startTime, endTime: s.endTime })),
			};
		});
	};

	// Collapse the multi-window slots to the wizard's single-window contract:
	// days with >=1 slot, plus the earliest start / latest end across all slots.
	slotsToLegacy = (slots) => {
		const selectedDays = [false, false, false, false, false, false, false];
		let earliest = null;
		let latest = null;
		(slots || []).forEach((s) => {
			if (typeof s.day === 'number' && s.day >= 0 && s.day <= 6) {
				selectedDays[s.day] = true;
			}
			const st = moment(s.startTime, 'h:mm A');
			const et = moment(s.endTime, 'h:mm A');
			if (st.isValid() && (!earliest || st.isBefore(earliest))) earliest = st;
			if (et.isValid() && (!latest || et.isAfter(latest))) latest = et;
		});
		return {
			selectedDays,
			startTime: earliest ? earliest.format('hh:mm A') : '09:00 AM',
			endTime: latest ? latest.format('hh:mm A') : '05:00 PM',
		};
	};

	createUserBot = async () => {
		const {
			selectedLoc,
			hrDuration,
			minDuration,
			confirmationMsg,
			autobotTemplate,
			brandName,
			careerSiteUrl,
			maxPerInterviewSlot,
			includeStoreLocation,
			noInterviewsWithin,
			scheduleSequence
		} = this.state;

		let data = { selectedLoc };
		if (this.state.steps.includes('calendar')) {
			const { selectedDays, startTime, endTime } = this.slotsToLegacy(this.state.interviewSlots);
			data = {
				...data,
				interviewSchedule: this.slotsToSchedule(this.state.interviewSlots),
				selectedDays,
				startTime,
				endTime,
				hrDuration,
				minDuration,
				confirmationMsg,
				hasCalendar: true,
				maxPerInterviewSlot,
				includeStoreLocation,
				noInterviewsWithin,
				scheduleSequence,
			};
		}
		
		if(this.state.hasQR){
			data.autoSmbData = {
				brandName,
				careerSiteUrl,
				autobotTemplate
			}
		}
		
		await createUserBot(data);

		// Refresh the session's cached bot list so the message composer
		// (MessageInputField) can find the freshly-assigned 1-1 longcode right
		// after onboarding. Without this, userData.bots is still the stale list
		// from login and "Send your first SMS" reports no texting number.
		const userBots = await getAssignedBots();
		const userData = session.get('userData');
		userData.bots = userBots.data;

		if(this.state.hasQR){
			//reload qrImage and session abtnumber
			const abt = _.find(userBots.data,{'default':null,'type':'nexmo'})
			const qrImage = `${config.api.host}/api/v1/files/bot/qr/${abt? abt.qr_image : ""}`
			this.setState({ qrImage});

			userData.default_abt=abt.mobile
			userData.qr_image=abt.qr_image
		}

		session.set('userData',userData)
	};

	searchLocation = val => async () => {
		try {
			const res = await searchLocation({ location: val });
			this.setState({ zones: res });
		} catch (err) {
			this.setState({ showSnackBar: true, snackBarMessage: err.message });
		}
	};

	render() {
		const { stepIndex, steps, skips } = this.state;

		const slotErrors = this.getSlotErrors(this.state.interviewSlots);
		const calendarHasSlotError = slotErrors.some(Boolean);


		const loader = (
      <Row>
        <Col xs={24} className="text-center">
          <h1>We're getting things ready</h1>
          <h4>This will only take a few moments</h4>
          <br/>
          <br/>
          <p>
            <SpinnerDotted color="#39B54A" />
          </p>
        </Col>
      </Row>
    )

		let styles = {
			gridFluid: {
				height: '100%',
				backgroundColor: 'white',
				overflowY: 'auto',
				paddingBottom: '180px'
			},
			contentContainer: {
				width: '85%',
				margin: 'auto'
			},
			btnContainer: {
				paddingTop: '12px',
				paddingBottom: '12px',
				borderTop: '1px solid #bdbdbd',
				zIndex: '1100',
				width: '85%',
				position: 'fixed',
				bottom: 0,
				marginBottom: '15px',
				background: 'rgba(255, 255, 255, 0.9)'
			}
		};

		const locationProps = {
			zones: this.state.zones,
			zone: this.state.zone,
			setLocation: (val, isSearch) => {
				if (this.state.timeout) clearTimeout(this.state.timeout);

				let timot;
				if (isSearch) timot = setTimeout(this.searchLocation(val), 500);
				this.setState({ zone: val, timeout: timot });
			},
			selectLocation: obj => this.setState({ selectedLoc: obj })
		};

		const calendarProps = {
			noInterviewsWithinNumber: this.state.noInterviewsWithinNumber,
            noInterviewsWithinPeriod: this.state.noInterviewsWithinPeriod,
			interviewSlots: this.state.interviewSlots,
			slotErrors,
			hrDuration: this.state.hrDuration,
			minDuration: this.state.minDuration,
			confirmationMsg: this.state.confirmationMsg,
			maxPerInterviewSlot: this.state.maxPerInterviewSlot,
			scheduleSequence:this.state.scheduleSequence,
			includeStoreLocation: this.state.includeStoreLocation,
			noInterviewsWithin: this.state.noInterviewsWithin,
			handleOnChange: this.handleOnChange,
			handleIncludeStoreLocationCheck: this.handleIncludeStoreLocationCheck,
			addSlot: this.addSlot,
			removeSlot: this.removeSlot,
			updateSlot: this.updateSlot
		};


		const autobotProps = { 
			brandName: this.state.brandName,
			name: this.state.name,
			email: this.state.email,
			careerSiteUrl: this.state.careerSiteUrl,
			careerSiteError: this.state.careerSiteError,
			brandNameError: this.state.brandNameError,
			selectedTemplate: this.state.autobotTemplate,
			botTemplates: this.state.botTemplates,
			handleOnSelectTemplate: this.handleSelectTemplate,
			handleOnChange: this.handleOnChange,
			handleOnBack: ()=>{},
			handleOnBuy: ()=>{},
			script: this.state.script
		  }

		let content;
		switch (steps[stepIndex]) {
			case 'welcome':
				content = this.state.hasQR ? <WelcomeDoneForYouContent autobotProps={autobotProps}/>:<WelcomeContent /> ;
				break;
			case 'location':
				content = <LocationConfig locationProps={locationProps} />;
				break;
			case 'calendar':
				content = <CalendarConfig calendarProps={calendarProps} />;
				break;
			default:
				content = <SetupComplete hasQR={this.state.hasQR} qrImage={this.state.qrImage}/>;
				break;
		}

		const stepList = ['Welcome page', 'Location'];
		if (steps.includes('calendar')) {
			stepList.push('Calendar Settings');
		}
		
		stepList.push('Setup Complete');

		const stepItems = stepList.map((step) => ({ title: step }));

		return (
      <div style={styles.gridFluid} id="create-campaign">
        <div style={styles.contentContainer}>
          <Row align="middle" gutter={16} style={{ marginBottom: 24 }}>
            <Col xs={24} sm={4}>
              <div className='setup-nav-btn-container' style={{ alignItems: 'start' }}>
                <Button
                  icon={<ArrowLeftOutlined />}
                  disabled={stepIndex === 0 || this.state.showLoader}
                  onClick={this.handlePrev}
                >
                  Back
                </Button>
              </div>
            </Col>
            <Col xs={24} sm={16}>
              <Steps
                size="small"
                responsive={false}
                current={stepIndex}
                items={stepItems}
              />
            </Col>
            <Col xs={24} sm={4}>
              <div
                className='setup-nav-btn-container'
                style={{
                  alignItems: 'center',
                  flexDirection: 'row',
                  justifyContent: 'flex-end',
                  gap: 10
                }}
              >
                <Button
                  type="primary"
                  disabled={
                    (steps[stepIndex] === 'calendar' &&
                    ((this.state.minDuration === 0 &&
                    this.state.hrDuration === 0) ||
                    this.state.maxPerInterviewSlot < 1 ||
                    (this.state.interviewSlots || []).length === 0 ||
                    calendarHasSlotError)) || this.state.showLoader
                  }
                  onClick={this.handleNext()}
                >
                  {steps[stepIndex] === 'complete' ? 'Complete' : 'Next'}
                  <ArrowRightOutlined />
                </Button>
                {skips.includes(steps[stepIndex]) && (
                  <Button onClick={this.handleNext(true)}>
                    Skip
                  </Button>
                )}
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={24}>{this.state.showLoader ? loader : content}</Col>
          </Row>
        </div>
      </div>
    )
	}
}

const mapStateToProps = state => {
	return {};
};

const mapDispatchToProps = dispatch => {
	return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
